import classNames from "classnames";

export default function PiButton(props: {
  children: JSX.Element[] | JSX.Element | string;
  variant: "piBlue" | "piRed" | "piBlueOutlined";
  onClick: () => void;
  disabled?: boolean;
  shadow?: boolean;
  "data-testid"?: string;
}) {
  const {
    variant,
    children,
    onClick,
    disabled,
    shadow,
    "data-testid": testId,
  } = { ...props };

  return (
    <div
      data-testid={testId}
      className={classNames({
        // 6px is the shared control radius - same as PiInputField and the MUI
        // pi* button variants in theme.tsx.
        "w-full flex h-full text-[14px] rounded-6": true,
        "bg-creator-error hover:bg-creator-error-hover cursor-pointer text-white":
          variant === "piRed" && !disabled,
        "bg-creator-primary hover:bg-creator-primary-hover cursor-pointer text-white":
          variant === "piBlue" && !disabled,
        "bg-creator-primary-background border border-solid border-creator-primary text-creator-primary box-border hover:bg-interaction-text-hoverBackground cursor-pointer":
          variant === "piBlueOutlined" && !disabled,
        "bg-creator-primary-disabled cursor-not-allowed text-white":
          disabled && variant === "piBlue",
        "bg-creator-primary-background border-interaction-disabled border cursor-not-allowed text-interaction-disabled":
          disabled && variant === "piBlueOutlined",
        "shadow-md": shadow !== null && shadow,
      })}
      onClick={!disabled ? onClick : undefined}
    >
      <div className="mx-auto my-auto w-full font-medium text-center font">
        {children}
      </div>
    </div>
  );
}
